import { z } from 'zod';

export const templateSummarySchema = z.object({
  templateId: z.string(),
  templateName: z.string(),
  signerCount: z.number().int(),
  fieldCount: z.number().int(),
});

export type TemplateSummary = z.infer<typeof templateSummarySchema>;

export const templateDesignSchema = z.object({
  templateId: z.string(),
  name: z.string(),
  /** Base64 of the .docx. */
  wordContent: z.string(),
  /** JSON array in a string — parsed by the caller, not here. */
  documentFields: z.string(),
  signerInfo: z.string(),
  stampInfo: z.string().nullable(),
});

export type TemplateDesign = z.infer<typeof templateDesignSchema>;

export const templateSavedSchema = z.object({
  templateId: z.string(),
});
